module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a5-5-4bca6d086de76738d23f733132e35a98.jpg";